import React from "react";
import { SVG, IconProps } from "../SVG";
export const Bank = ({ color = "#13126C", strokeWidth = 2, ...props }: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
        <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={strokeWidth}
            d="M3.765 22H22M2.455 22h19.09M6 12v7m6-7v7m6-7v7M12.006 2c-.298 0-.6.078-.893.239L2.223 7.52A.454.454 0 0 0 2 7.91v.637c0 .25.203.453.455.453h19.09A.453.453 0 0 0 22 8.547V7.91a.454.454 0 0 0-.222-.391l-8.892-5.28a1.787 1.787 0 0 0-.88-.24Z"
        />
    </SVG>
);
Bank.displayName = "Bank";
